import { createInventoryBrandPage } from "../../../components/create-inventory-brand-page";
import db from "../../../utils/parts-denison.json";
export default createInventoryBrandPage("denison");

export async function getStaticProps() {
	return { props: { db } };
}
